module.exports = __webpack_public_path__ + "static/media/location.1b2349bb.svg";